import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import ImageSkeleton from '../../components/Skeleton/ImageSkeleton';
import TextSkeleton from '../../components/Skeleton/TextSkeleton';

import { getCasoExito } from '../../config/services/strapi/strapi';

import { CasoExito } from '../../interfaces/types';

function DetalleCasoExito() {
  const [cargando, setCargando] = useState(true);
  const [casoExito, setCasoExito] = useState<CasoExito | null>(null);

  useEffect(() => {
    const fetchCasoExito = async () => {
      setCargando(true);
      const slug = window.location.pathname.split('/').pop() || '';
      const caso = await getCasoExito(slug);

      if (!caso) {
        console.error('No se encontró el caso de éxito');
        return;
      }

      setCasoExito({
        id: caso.id,
        comuna: caso.comuna,
        descripcion: caso.descripcion,
        destacado: caso.destacado,
        imagenes: caso.imagenes ? caso.imagenes.map((img: any) => ({
          url: img.url
        })) : [],
        impactos: caso.impactos,
        nombre: caso.nombre,
        banner: {
          url: caso.banner?.url
        },
        portada: {
          url: caso.portada?.url
        },
        provincia: caso.provincia,
        region: caso.region,
        rubro: caso.rubro,
        slug: caso.slug,
        fragmentoUrl: caso.fragmento_url || ''
      });

      setCargando(false);

      document.title = `${caso.nombre} | Gasco Soluciones Energéticas`;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    fetchCasoExito();
  }, []);

  return (
    <main>
      {/* Hero */}
      {
        cargando ?

          <ImageSkeleton className="w-full h-[300px] lg:h-[424.5px]" />

          :
        
          Boolean(casoExito?.banner) && <section className='w-full relative'>
            <div className='absolute left-[15px] lg:px-[92px] h-full flex flex-col justify-center'>
              <h1 className='!text-white !mt-0 !mb-[8.5px] !text-[25.5px] xl:!text-[48px] !font-[600] xl:!font-[500] leading-[30.6px] xl:!leading-[57.6px]'>{casoExito?.nombre || 'Cargando...'}</h1>
              <p className='!text-white !text-[17px] xl:!text-[30px] !font-[400] !leading-[23.8px] xl:!leading-[42px]'>{casoExito?.comuna || 'Cargando...'}</p>
            </div>
            <figure className='w-full h-auto !m-0 !h-[300px] lg:!h-[424.5px] xl:!h-[500px] 2xl:!h-[600px]'>
              <img src={casoExito?.banner?.url} className='w-full h-full object-cover' alt="" />
            </figure>
          </section>
      }
      {/* Descripcion */}
      <section>
        <div className="py-[51px] px-[15px] flex flex-col md:flex-row md:items-start lg:px-[92px]">
          <div className='w-full mb-[34px] md:pr-[50px]'>
            {
              cargando ?

                <TextSkeleton />

                :

                <p className='!text-[var(--text-color-primary)] !text-[12.75px] xl:!text-[18px] !font-[400] !leading-[20.4px] xl:!leading-[28.8px] !mt-[17px] !mb-[51px]'>
                  Ubicación: {casoExito?.comuna || 'Cargando...'}
                </p>
            }
            {

              cargando ?

                <TextSkeleton className="!mb-[51px]" />

                :

                casoExito?.impactos.map((impacto: any, index: number) => {
                  if (impacto.type === 'list') {
                    return (
                      <ul key={`impacto-list-${index}`} className='list-disc pl-5 mb-4 !list-["_-_"] !apearance-none'>
                        {
                          impacto.children.map((item: any, itemIndex: number) => (
                            <li key={`impacto-${itemIndex}`} className='!text-[var(--text-color-primary)] !text-[12.75px] xl:!text-[18px] !font-[400] !leading-[20.4px] xl:!leading-[28.8px]'>
                              {
                                item?.children?.map((child: any, childIndex: number) => {
                                  if (child.type === 'text') {
                                    return (
                                      <span key={`impacto-${itemIndex}-${childIndex}`} className='!text-[var(--text-color-primary)] !text-[12.75px] xl:!text-[18px] 2xl:!text-[28px] !font-[400] !leading-[20.4px] 2xl:!leading-[40.8px]'>
                                        {child.text}
                                      </span>
                                    );
                                  }
                                  return null;
                                })
                              }
                            </li>
                          ))
                        }
                      </ul>
                    )
                  }
                })
            }
            <div className="flex">
              <NavLink
                to="/contacto"
                className='!text-white !text-[11.9px] xl:!text-[16.8px] !font-[400] leading-[17.85px] !bg-[var(--background-color-primary)] flex justify-center items-center !mt-[17px] px-[18px] py-[11.05px] border-[1px] border-[var(--border-color-secondary)] rounded-lg'
              >
                Contacta a un especialista
              </NavLink>
            </div>
          </div>
          <div className='w-full md:pl-[50px]'>
            {
              cargando ?

                <>
                  <TextSkeleton className="!mb-[51px]" />
                  <TextSkeleton className="!mb-[51px]" />
                  <TextSkeleton className="!mb-[51px]" />
                </>

                :

                casoExito?.descripcion.map((item: any, itemindex: number) => {
                  if (item.type === 'paragraph') {
                    return (
                      <p key={`item-${itemindex}`} className='mb-4'>
                        {
                          item.children.map((child: any, childIndex: number) => {
                            if (child.type === 'text') {
                              return (
                                <span key={`item-${itemindex}-${childIndex}`} className='!text-[var(--text-color-primary)] !text-[12.75px] xl:!text-[18px] !leading-[20.42px] xl:!leading-[28.8px] !font-[400] lg:px-0 mb-[17px]'>
                                  {child.text}
                                </span>
                              );
                            }

                            if (child.type === 'link') {
                              return (
                                <NavLink key={`item-${itemindex}-${childIndex}`}
                                  to={child.url}
                                  className='!text-[var(--text-color-secondary)] !text-[11.9px] !leading-[20.4px] !font-[400] lg:px-0 mb-[17px]'
                                >
                                  {child.children[0]?.text || ''}
                                </NavLink>
                              );
                            }
                          })
                        }
                      </p>
                    )
                  }

                  else if (item.type === 'list') {
                    return (
                      <ul key={`item-${itemindex}`} className='list-disc pl-5 mb-4 !list-["_-_"] !apearance-none'>
                        {
                          item.children.map((listItem: any, listIndex: number) => (
                            <li key={`item-${itemindex}-${listIndex}`} className='!text-[var(--text-color-primary)] !text-[11.9px] 2xl:!text-[18px] !leading-[21.42px] 2xl:!leading-[40.8px] !font-[400]'>
                              <span>{listItem.children[0]?.text || ''}</span>
                            </li>
                          ))
                        }
                      </ul>
                    )
                  }
                })
            }
            {

              cargando ?

                <ImageSkeleton className="w-full h-[435px] !m-0 !p-0" />

                :
            
                casoExito?.fragmentoUrl && <figure className='w-full h-full !m-0 !p-0'>
                  <div className='w-full'>
                    <iframe
                      className='w-full h-[435px] !m-0 !p-0 overflow-hidden'
                      src={casoExito?.fragmentoUrl}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  </div>
                </figure>
            }
          </div>
        </div>
      </section>
      {/* Galería */}
      <section>
        <div className="grid grid-cols-12 gap-4 px-[15px] lg:px-[92px] pb-[15px]">
          {
            cargando ?

              <ImageSkeleton className="col-span-12 md:col-span-8 h-[300px] lg:h-[424.5px]" />

              :

              <figure
                className="w-full h-full !m-0 !p-0 col-span-12 md:col-span-8"
              >
                <img src={casoExito?.imagenes[0]?.url} alt={casoExito?.nombre} className="w-full h-auto" />
              </figure>
          }
          <div className="col-span-12 md:col-span-4 md:flex md:flex-col gap-4">
            {
              cargando ?

                <ImageSkeleton className="h-[300px] lg:h-[424.5px]" />

                :

                casoExito?.imagenes[1] && (<figure
                  className="w-full h-auto mb-4 !mx-0 !mt-0 md:!m-0 !p-0 md:max-h-[160px] lg:max-h-[273px] xl:max-h-[506px]"
                >
                  <img src={casoExito?.imagenes[1]?.url} alt={casoExito?.nombre} className="w-full h-auto" />
                </figure>)
            }
            {
              cargando ?

                <ImageSkeleton className="h-[300px] lg:h-[424.5px]" />

                :

                casoExito?.imagenes[2] && (<figure
                  className="w-full h-auto !m-0 !p-0 md:max-h-[225px] lg:max-h-[345px] xl:max-h-[640px]"
                >
                  <img src={casoExito?.imagenes[2]?.url} alt={casoExito?.nombre} className="w-full h-auto" />
                </figure>)
            }
          </div>
        </div>
      </section>
    </main>
  )
}

export default DetalleCasoExito